export class Profile {
    CalorificValuePerDay: number;
    CarbohydratesPerDay: number;
    Description: string;
    FatsPerDay: number;
    FullName: string;
    Id_Profile: number;
    Id_User: number;
    IsCalcCal: number;
    IsShowCal: number;
    PortionWeight: number;
    ProteinsPerDay: number;
    UserName: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/profile-menu.ts